import React, { FC } from 'react';
import { useRouteMatch } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Tabs as MuiTabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { GroupFragment } from 'api';
import * as paths from 'paths';
import { useCurrentUser } from 'hooks';
import { generateLink } from 'Links';

import { canModerateGroupContent } from '../../helpers';

interface IProps {
  group: GroupFragment;
}

const useStyles = makeStyles({
  root: {
    borderBottom: 0,
  },
});

const Tabs: FC<IProps> = ({ group }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const match = useRouteMatch();
  const currentUser = useCurrentUser();
  const canModerate = canModerateGroupContent(currentUser, group.id);

  const PostsLink = generateLink(`/group/${group.id}`);
  const MembersLink = generateLink(`/group/${group.id}/members`);

  function getAdminLinks() {
    const ApprovalLink = generateLink(`/group/${group.id}/approval`);
    const ScheduledLink = generateLink(`/group/${group.id}/scheduled`);
    const RemovedLink = generateLink(`/group/${group.id}/removed`);

    return [
      <Tab
        key={paths.groupApproval}
        label={t('admin:forApproval')}
        value={paths.groupApproval}
        component={ApprovalLink}
      />,
      <Tab
        key={paths.groupScheduled}
        label={t('common:scheduled')}
        value={paths.groupScheduled}
        component={ScheduledLink}
      />,
      <Tab
        key={paths.groupRemoved}
        label={t('admin:removed')}
        value={paths.groupRemoved}
        component={RemovedLink}
      />,
    ];
  }

  return (
    <MuiTabs value={match.path} className={classes.root}>
      <Tab label={t('common:post_plural')} value={paths.group} component={PostsLink} />
      <Tab label={t('common:member_plural')} value={paths.groupMembers} component={MembersLink} />
      {canModerate && getAdminLinks()}
    </MuiTabs>
  );
};

export default Tabs;
